import { useFormik } from "formik"
import React, { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import {
    Card,
    CardBody,
    Col,
    Container,
    Label,
    Row
} from "reactstrap"
import * as Yup from "yup"

import Breadcrumbs from "components/Common/BreadcrumbTitle"

import CommonDialog from "components/Common/CommonDialog"

import { getSignupInquiryList, addSignupInquiryList, editSignupInquiryList, getOneSignupInquiryList } from "../../helpers/UAM/signInquiry.helper";

const ViewSignupInquiry = props => {

    const navigate = useNavigate();

    const location = useLocation();
    const pathnameSegments = location.pathname.split('/');
    const lastSegment = pathnameSegments[pathnameSegments.length - 1];
    const formattedLastSegment = lastSegment.charAt(0).toUpperCase() + lastSegment.slice(1).toLowerCase();

    document.title = `${formattedLastSegment} Dealer Inquiry | DMS`

    const urlParams = new URLSearchParams(window.location.search);
    const encodedId = urlParams.get("id");
    const decodedId = atob(encodedId);

    const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
    const [signInquiryList, setSignInquiryList] = useState({})
    const [showViewSignInquiry, setShowViewSignInquiry] = useState(false);
    const [signInquiryData, setSignInquiryData] = useState([]);

    useEffect(() => {
        if (lastSegment == 'view') {
            getOneSignupInquiryList({ id: decodedId })
                .then(responseFromAPI => {
                    if (responseFromAPI.status && responseFromAPI.code == 200) {
                        let responseData = responseFromAPI.data[0]
                        setSignInquiryList(responseData)
                    }
                })
                .catch(error => { })
        }

        if (lastSegment == "view") {
            setShowViewSignInquiry(true)
        } else {
            setShowViewSignInquiry(false)
        }
        getSignupInquiryList()
            .then((response) => {
                if (response.status && response.code == 200) {
                    setSignInquiryData(response?.data.data)
                }
            }).catch((error) => {
                console.log(error)
            })

    }, []);

    // validation

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            id: (signInquiryList.id) || "",
            personName: (signInquiryList.personName) || "",
            email: (signInquiryList.email) || "",
            phone: (signInquiryList.phone) || "",
            companyName:(signInquiryList.companyName) ||"",
            inquiryStatus: (signInquiryList.inquiryStatus) || "",
        },
        // validationSchema: inquiryValidationSchema,
        onSubmit: values => { },
    })

    const navigateBack = () => {
        navigate(-1)
    }
    const dialogAction = (action, data) => {
        if (action == 1) {
            setShowCommonDialog({ isShow: false })
        } else {
            setShowCommonDialog({ isShow: false })
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title={`${lastSegment.toUpperCase()} Dealer Inquiry`} />
                        <Row className="vertical-scroll">
                            <Col xs="12">
                                <Card>
                                    <CardBody>
                                        {showViewSignInquiry && (
                                            <div>
                                            <Row>
                                                <Col sm={5}>
                                                    <Label
                                                        className="col-sm-6 col-form-label label label-styling"
                                                    >
                                                        Inquiry Number
                                                    </Label>
                                                    <p>{signInquiryList.id || "-"}</p>
                                                </Col>
                                                <Col sm={5}>
                                                    <Label
                                                        className="col-sm-6 col-form-label label label-styling"
                                                    >
                                                        Person Name
                                                    </Label>
                                                    <p>{signInquiryList.personName || "-"}</p>
                                                </Col>
                                                </Row>
                                                <Row className="mb-4">
                                                <Col sm={5}>
                                                    <Label
                                                        className="col-sm-6 col-form-label label label-styling"
                                                    >
                                                        Email
                                                    </Label>
                                                    <p>{signInquiryList.email || "-"}</p>
                                                </Col>
                                            
                                            
                                                <Col sm={5}>
                                                    <Label
                                                        className="col-sm-6 col-form-label label label-styling"
                                                    >
                                                        Mobile Number
                                                    </Label>
                                                    <p>{signInquiryList.phone || "-"}</p>
                                                </Col>
                                                <Col sm={5}>
                                                    <Label
                                                        className="col-sm-6 col-form-label label label-styling"
                                                    >
                                                        Status
                                                    </Label>
                                                    <p>{signInquiryList.inquiryStatus || "-"}</p>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col>
                                                    <div>
                                                        <button
                                                            className="btn btn-outline-secondary"
                                                            onClick={() => {
                                                                navigateBack()
                                                            }}
                                                        >
                                                            Back
                                                        </button>
                                                    </div>
                                                </Col>
                                            </Row>
                                            </div>
                                        )

                                        }
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    
                </Container>
            </div>
        </React.Fragment>
    )



}
export default ViewSignupInquiry